import React from "react";

const ShiftTimes = ({ shiftData }) => {
  return (
    <>
      {shiftData?.length > 0 ? (
        <div className="shifts-container mt30">
          {shiftData.map((shift, index) => (
            <div className="shift-box" key={index}>
              <div className="shift-time">
                <span>
                  <b>{shift?.start_time || "-"}</b> -{" "}
                  <b>{shift?.end_time || "-"}</b>
                </span>
              </div>

              <div className="staff-counts">
                <div
                  className="tag-value"
                  style={{
                    background: "rgb(245, 97, 49)",
                  }}
                >
                  <span className="tag">Sales Executive:</span>
                  <span className="value">{shift?.data?.staff || 0}</span>
                </div>
                <div
                  className="tag-value"
                  style={{
                    background: "rgb(20, 117, 171)",
                  }}
                >
                  <span className="tag">Trainer:</span>
                  <span className="value">{shift?.data?.trainer || 0}</span>
                </div>
                <div
                  className="tag-value"
                  style={{
                    background: "rgb(78, 159, 61)",
                  }}
                >
                  <span className="tag">Member:</span>
                  <span className="value">{shift?.data?.member || 0}</span>
                </div>
                <div
                  className="tag-value"
                  style={{
                    background: "rgb(92, 82, 127)",
                  }}
                >
                  <span className="tag">Guest:</span>
                  <span className="value">{shift?.data?.guest || 0}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <span className="info">No Shift Found!</span>
      )}
    </>
  );
};

export default ShiftTimes;
